import React, { useEffect, useRef } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import useStyles from './styles';
import { wagonNumberListState } from '../HomePage/ContentTabs/ContentTabsSlice';
import { userInfoState } from '../HomePage/HomeSlice';
import { setWagonNumberResearched } from '../WagonDetailsPage/WagonDetailsPageSlice';

export default function WagonNumberAutoComplete(props) {
  const {
    selectedTab,
    wagonNumber,
    deletedIntegrated,
    errorPresent,
    errorMessage,
    addingInvoice,
  } = props;
  const [filteredWagonNumberList, setFilteredWagonNumberList] = React.useState(
    [],
  );
  const user = useSelector(userInfoState);
  const wagonNumberList = useSelector(wagonNumberListState);
  const [wagonNumberFilteredList, setWagonFilteredList] = React.useState([]);
  const classes = useStyles();
  const mountedRef = useRef(true);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (history.location.pathname.startsWith('/wagon/search')) {
      dispatch(setWagonNumberResearched(''));
    }
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    let wagonNumberObjects = wagonNumberList;
    if (!(deletedIntegrated && user.hasAllRights)) {
      wagonNumberObjects = wagonNumberList.filter(
        (wagon) => wagon.deletedFromFleet === false,
      );
    }
    const wagonNumbers = wagonNumberObjects.map((wagon) => {
      return wagon.wagonNumber;
    });

    setWagonFilteredList(wagonNumbers);
  }, [user, deletedIntegrated, wagonNumberList]);

  function filteringWagonNumber(wagonNumberItem) {
    let input = wagonNumber;
    let endingWord = true;
    let beginWord = true;
    if (
      wagonNumber.startsWith('*') &&
      wagonNumber.endsWith('*') &&
      wagonNumber.length > 1
    ) {
      input = wagonNumber.substring(1, wagonNumber.lastIndexOf('*'));
      endingWord = !wagonNumberItem.endsWith(input);
      beginWord = !wagonNumberItem.startsWith(input);
    } else if (wagonNumber.startsWith('*')) {
      input = wagonNumber.substring(1);
      beginWord = !wagonNumberItem.startsWith(input) || input.length === 0;
      endingWord = wagonNumberItem.endsWith(input);
    } else if (wagonNumber.endsWith('*')) {
      input = wagonNumber.substring(0, wagonNumber.lastIndexOf('*'));
      endingWord = !wagonNumberItem.endsWith(input);
      beginWord = wagonNumberItem.startsWith(input);
    }
    return wagonNumberItem.includes(input) && endingWord && beginWord;
  }

  useEffect(() => {
    const filteredList = wagonNumberFilteredList.filter(filteringWagonNumber);
    const first100filteredList = filteredList.slice(0, 100);
    setFilteredWagonNumberList(first100filteredList);
  }, [wagonNumber, wagonNumberFilteredList]);

  function preventNonNumericalInput(e) {
    const charCode = typeof e.which === 'undefined' ? e.keyCode : e.which;
    const charStr = String.fromCharCode(charCode);
    if (!charStr.match(/^\*|[0-9]+$/)) e.preventDefault();
    if (!user.internal && charStr.includes('*')) {
      e.preventDefault();
    }
  }

  const setOptionSelected = (option, value) => {
    return option === value;
  };

  const handleInputChange = (event, newInputValue) => {
    if (errorPresent && mountedRef.current) {
      props.setErrorMessage(null);
      props.setErrorPresent(false);
    }
    if (mountedRef.current && event) {
      if (event.nativeEvent.inputType === 'insertCompositionText') {
        newInputValue = newInputValue.replace(/¨|\^|`?/g, '');
      }
      if (event.nativeEvent.inputType === 'insertFromPaste') {
        newInputValue = newInputValue
          .replace(/[^0-9*]+/g, '')
          .replace(
            /¨|\^|`|-|ù|%|£|=|\+|:|\/|;|\.|,|\?|<|>|e|ä|ë|ï|ö|ü|Ë|Ä|Ï|Ö|Ü?/g,
            '',
          );
      }
      if (!user.internal && newInputValue.includes('*')) {
        newInputValue.replace('*', '');
      }
      props.setWagonNumber(newInputValue);
    }
  };

  return (
    <Autocomplete
      data-testid="wagon-number-autocomplete"
      classes={{
        option: classes.option,
        input: addingInvoice ? classes.addingInvoiceInput : classes.input,
        inputRoot: classes.inputRoot,
      }}
      size="small"
      freeSolo
      disablePortal={selectedTab === 'wagonDetails'}
      options={filteredWagonNumberList}
      value={wagonNumber}
      renderInput={(params) => (
        <TextField
          className={
            addingInvoice
              ? classes.autocompleteAddingInvoice
              : classes.autocomplete
          }
          required
          placeholder={t('Enter Wagon Number')}
          type="text"
          error={errorPresent}
          helperText={t(errorMessage)}
          variant="outlined"
          {...params}
          FormHelperTextProps={{ className: classes.helperText }}
        />
      )}
      getOptionSelected={setOptionSelected}
      onInputChange={handleInputChange}
      onKeyPress={preventNonNumericalInput}
    />
  );
}
